import axios from 'axios';
import Cookies from 'js-cookie';

const API_BASE_URL = process.env.REACT_APP_API_URL || '/api';
const HOST_LANGUAGES = ['fa', 'en', 'ja', 'de', 'pt', 'fr', 'it', 'es', 'ko', 'hi', 'zh'];

const languageFromHost = (hostname) => {
  const host = String(hostname || '').toLowerCase();
  const labels = host.split('.');
  if (labels.length > 2 && HOST_LANGUAGES.includes(labels[0])) {
    return labels[0];
  }
  if (host === 'potterhead.ir' || host === 'www.potterhead.ir' || host.endsWith('.potterhead.ir')) {
    return 'fa';
  }
  if (host === 'potterheads.org' || host === 'www.potterheads.org' || host.endsWith('.potterheads.org')) {
    return 'en';
  }
  return 'fa';
};

const isLocalHost = (hostname) => hostname === 'localhost' || hostname === '127.0.0.1';

const client = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Add token to requests
client.interceptors.request.use((config) => {
  const token = Cookies.get('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  // اضافه کردن هدر زبان برای پاسخ‌های چندزبانه بک‌اند
  try {
    const host = typeof window !== 'undefined' && window.location ? window.location.hostname.toLowerCase() : '';
    const savedLang = localStorage.getItem('language');
    if (host && !isLocalHost(host)) {
      config.headers['X-Language'] = languageFromHost(host);
    } else if (savedLang) {
      config.headers['X-Language'] = savedLang;
    } else if (host) {
      config.headers['X-Language'] = languageFromHost(host);
    }
  } catch (_) {
    config.headers['X-Language'] = 'fa';
  }

  // اگر body یک FormData است، Content-Type را حذف کن تا مرورگر boundary را
  // خودکار اضافه کند (بدون boundary، multer نمی‌تواند فایل را parse کند).
  if (config.data instanceof FormData) {
    delete config.headers['Content-Type'];
    delete config.headers['content-type'];
    if (config.headers.delete) {
      config.headers.delete('Content-Type');
      config.headers.delete('content-type');
    }
  }
  return config;
});

// Handle responses
client.interceptors.response.use(
  (response) => response,
  (error) => {
    const requestUrl = error.config?.url || '';
    const isLoginRequest = [
      '/auth/admin/login',
      '/auth/login',
      '/auth/request-otp',
      '/auth/verify-otp'
    ].some(path => requestUrl.includes(path));

    if (error.response?.status === 401 && !isLoginRequest) {
      Cookies.remove('token');
      Cookies.remove('admin');
      const nextPath = window.location.pathname.startsWith('/admin') ? '/admin/login' : '/portal-9-3-4';
      window.location.href = nextPath;
    }
    // کاربر مسدود شده — از هر صفحه‌ای که این درخواست زده شده باشد (داشبورد،
    // چت، سفر و ...) او را به صفحه‌ی اختصاصی «دسترسی مسدود شد» می‌فرستیم.
    if (error.response?.status === 403 && error.response?.data?.code === 'BANNED') {
      try {
        sessionStorage.setItem('banReason', error.response.data.banReason || '');
      } catch (_) {}
      Cookies.remove('token');
      if (window.location.pathname !== '/banned') {
        window.location.href = '/banned';
      }
    }
    return Promise.reject(error);
  }
);

export default client;
